const SCALE_REGEX = /scale\([^)]*\)/;

/* eslint-disable no-param-reassign */

function setNodeTransformScale(node, value) {
  if (!node) return;
  if (!node.style.transform || node.style.transform === 'none') {
    node.style.transform = `scale(${value})`;
    return;
  }

  if (node.style.transform.includes('scale')) {
    node.style.transform = node.style.transform.replace(SCALE_REGEX, `scale(${value})`);
  } else {
    node.style.transform += ` scale(${value})`;
  }
}

export default setNodeTransformScale;
